<template>
  <section class="about-container">

    <!-- HERO -->
    <div class="about-hero">
      <h1 class="about-title">Sobre Nosotros</h1>

      <p class="about-intro">
        Somos una <strong>empresa mexicana de soluciones digitales</strong>
        enfocada en <strong>tecnología e innovación</strong> para impulsar
        negocios modernos.
      </p>
    </div>

    <!-- MISIÓN -->
    <div class="about-section">
      <h2 class="about-subtitle">Nuestra Misión</h2>

      <p>
        Ayudamos a empresas y emprendedores a optimizar sus operaciones mediante
        <strong>herramientas digitales</strong>, procesos eficientes y
        soluciones tecnológicas personalizadas.
      </p>

      <p>
        Nuestro objetivo es simplificar lo complejo, reducir errores y mejorar
        la productividad desde el primer día.
      </p>
    </div>

    <!-- VISIÓN -->
    <div class="about-section">
      <h2 class="about-subtitle">Nuestra Visión</h2>

      <p>
        Convertirnos en un referente en
        <strong>transformación digital</strong> para pequeñas y medianas
        empresas, ofreciendo soluciones accesibles, escalables y de alto
        impacto.
      </p>
    </div>

    <!-- VALORES -->
    <div class="about-section">
      <h2 class="about-subtitle">Nuestros Valores</h2>

      <div class="values-grid">

        <div class="value-card">
          <h3>Innovación</h3>
          <p>
            Buscamos constantemente nuevas formas de mejorar y evolucionar.
          </p>
        </div>

        <div class="value-card">
          <h3>Calidad</h3>
          <p>
            Nos enfocamos en ofrecer soluciones confiables y bien ejecutadas.
          </p>
        </div>

        <div class="value-card">
          <h3>Compromiso</h3>
          <p>
            Trabajamos de la mano con nuestros clientes para lograr resultados
            reales.
          </p>
        </div>

        <div class="value-card">
          <h3>Eficiencia</h3>
          <p>
            Optimizamos procesos para ahorrar tiempo y recursos.
          </p>
        </div>

      </div>
    </div>

  </section>
</template>

<script>
import { useHead } from "@vueuse/head";

export default {
  name: "AboutComponent",

  setup() {

    useHead({

      /* TITLE */
      title: "Sobre Nosotros | Raptoris",

      /* META */
      meta: [

        {
          name: "description",
          content:
            "Conoce nuestra misión, visión y valores. Somos una empresa mexicana especializada en transformación digital, innovación y soluciones tecnológicas."
        },

        {
          name: "keywords",
          content:
            "empresa mexicana, transformación digital, innovación, soluciones tecnológicas, software, automatización, tecnología"
        },

        {
          name: "author",
          content: "Raptoris"
        },

        /* OPEN GRAPH */
        {
          property: "og:type",
          content: "website"
        },

        {
          property: "og:title",
          content: "Sobre Nosotros | Raptoris"
        },

        {
          property: "og:description",
          content:
            "Empresa mexicana enfocada en innovación, automatización y soluciones tecnológicas para negocios modernos."
        },

        {
          property: "og:url",
          content: "https://raptoris.com/nosotros"
        },

        {
          property: "og:image",
          content: "https://raptoris.com/images/img17.jpg"
        },

        {
          property: "og:site_name",
          content: "Raptoris"
        },

        /* TWITTER */
        {
          name: "twitter:card",
          content: "summary_large_image"
        },

        {
          name: "twitter:title",
          content: "Sobre Nosotros | Raptoris"
        },

        {
          name: "twitter:description",
          content:
            "Conoce más sobre nuestra empresa y enfoque en innovación y transformación digital."
        },

        {
          name: "twitter:image",
          content: "https://raptoris.com/images/img17.jpg"
        }
      ],

      /* CANONICAL */
      link: [
        {
          rel: "canonical",
          href: "https://raptoris.com/nosotros"
        }
      ]
    });
  }
};
</script>

<style scoped>

.about-container{
  padding:4rem 2rem;
  max-width:1200px;
  margin:0 auto;

  color:var(--negro);

  background:
    linear-gradient(
      180deg,
      #f8fbfa 0%,
      #eef5f2 100%
    );

  border-radius:20px;

  animation:fadeIn 1s ease;
}

/* HERO */
.about-hero{
  text-align:center;
  margin-bottom:4rem;
  position:relative;
  padding:2rem 1rem;
}

.about-title{
  font-size:3rem;
  font-weight:800;
  letter-spacing:1px;

  background:
    linear-gradient(
      135deg,
      #013a25,
      #1a8b60
    );

  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;

  margin-bottom:1rem;

  animation:fadeInDown .8s ease;
}

.about-intro{
  font-size:1.2rem;
  color:#555;

  max-width:700px;
  margin:0 auto;

  line-height:1.7;
}

/* SECTIONS */
.about-section{
  margin-bottom:3rem;

  padding:2rem;

  border-radius:16px;

  background:rgba(255,255,255,.6);

  backdrop-filter:blur(12px);

  box-shadow:
    0 10px 30px rgba(0,0,0,.08);

  transition:
    transform .25s ease,
    box-shadow .25s ease;

  animation:fadeInUp 1s ease;
}

.about-section:hover{
  transform:translateY(-4px);

  box-shadow:
    0 15px 40px rgba(0,0,0,.12);
}

.about-subtitle{
  font-size:1.9rem;
  margin-bottom:1rem;

  color:var(--primario);

  position:relative;
}

.about-subtitle::before{
  content:"";

  position:absolute;

  left:-10px;
  top:50%;

  transform:translateY(-50%);

  width:4px;
  height:70%;

  border-radius:10px;

  background:var(--primario);
}

.about-section p{
  line-height:1.8;
  margin-bottom:.8rem;

  color:#444;
  font-size:1.05rem;
}

/* VALUES */
.values-grid{
  display:grid;

  grid-template-columns:
    repeat(auto-fit, minmax(230px, 1fr));

  gap:1.5rem;

  margin-top:1.5rem;
}

.value-card{
  background:white;

  padding:1.8rem;

  border-radius:16px;

  position:relative;
  overflow:hidden;

  box-shadow:
    0 10px 25px rgba(0,0,0,.08);

  transition:all .3s ease;
}

.value-card:hover{
  transform:
    translateY(-8px)
    scale(1.02);

  box-shadow:
    0 20px 40px rgba(0,0,0,.15);
}

.value-card h3{
  margin-bottom:.7rem;

  color:#065f46;

  font-size:1.2rem;
}

.value-card p{
  color:#555;
  line-height:1.7;
}

/* ANIMATIONS */
@keyframes fadeIn{
  from{
    opacity:0;
  }

  to{
    opacity:1;
  }
}

@keyframes fadeInDown{
  from{
    opacity:0;
    transform:translateY(-20px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }
}

@keyframes fadeInUp{
  from{
    opacity:0;
    transform:translateY(20px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }
}

/* TABLET */
@media (max-width:768px){

  .about-container{
    padding:2rem 1rem;
  }

  .about-title{
    font-size:2.3rem;
  }

  .about-intro{
    font-size:1rem;
  }

  .about-section{
    padding:1.5rem;
  }

}

/* MOBILE */
@media (max-width:500px){

  .about-title{
    font-size:2rem;
  }

  .about-subtitle{
    font-size:1.5rem;
  }

  .about-section p{
    font-size:.96rem;
  }

}

</style>